import(/* webpackMode: "eager" */ "/home/webimports-dev/htdocs/web-imports/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/webimports-dev/htdocs/web-imports/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/webimports-dev/htdocs/web-imports/src/components/layout/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/AccessibleFocus.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/PageTransition.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/webimports-dev/htdocs/web-imports/src/components/ui/WebVitalsScript.tsx");
